import { Divider } from "@heroui/react";
import { useTranslation } from "react-i18next";
import PowerPickTimeZone from "./powerPickTimeZone";
import TimeZone from "./timeZone";
import DefaultWarehouse from "./warehouse";
import License from "./license";
import Url from "./url";
import DefaultMaterialProperty from "./materialProperty";
import Box from "/app/src/components/generic/components/box";
import NavigationMenus from "./navigationMenus";
import PowerPickPolling from "./powerPickPolling";
import OrderStatusCode from "./orderStatusCode";
import PowerPickVersion from "./powerPickVersion";
import ApiCallLogRetentionDays from "./apiCallLogRetentionDays";
import ApiCallLogMaxCount from "./apiCallLogMaxCount";
import RateLimits from "./rateLimits";

/**
 * Component to display the forms for updating the license, url, time zone, and default warehouse
 */
export default function General() {
  const { t } = useTranslation();
  return (
    <Box>
      <h1>{t("translation:general_settings")}</h1>
      <Divider className="my-6" />
      <Url />
      <Divider className="my-6" />
      <License />
      <Divider className="my-6" />
      <TimeZone />
      <Divider className="my-6" />
      <PowerPickTimeZone />
      <Divider className="my-6" />
      <DefaultWarehouse />
      <Divider className="my-6" />
      <DefaultMaterialProperty />
      <Divider className="my-6" />
      <PowerPickPolling />
      <Divider className="my-6" />
      <PowerPickVersion />
      <Divider className="my-6" />
      <RateLimits />
      <Divider className="my-6" />
      <OrderStatusCode />
      <Divider className="my-6" />
      <ApiCallLogRetentionDays />
      <Divider className="my-6" />
      <ApiCallLogMaxCount />
      <Divider className="my-6" />
      <NavigationMenus />
    </Box>
  );
}
